import React from "react";
import { useNavigate } from "react-router";

const Login = () => {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/list-customers");
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <form
        className="bg-white p-4 rounded shadow"
        style={{ minWidth: "30%" }}
        onSubmit={handleSubmit}
      >
        <h3 className="text-center mb-4">Login</h3>
        <div className="form-group">
          <label className="col-sm-4 col-form-label">User Name</label>
          <div className="col-sm-8">
            <input
              type="text"
              className="form-control form-control-sm"
              id="txtUserName"
            />
          </div>
          <label className="col-sm-4 col-form-label">Password</label>
          <div className="col-sm-8">
            <input
              type="password"
              className="form-control form-control-sm"
              id="txtPassword"
            />
          </div>
          <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary px-5">
            Login
          </button>
        </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
